import React, { Component } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


class EditorInput extends Component {
  constructor(props) {
    super(props);
    const html = props.input_value;
    const contentBlock = htmlToDraft(html);

    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
    
      this.state = {
        editorState,
      };
    
    }
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });
    this.props.input_onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())),this.props.input_parent, this.props.input_name);
  };

  render() {
    const { editorState } = this.state;
    const { 
        input_type, 
        input_name, 
        input_label, 
        input_value, 
        input_placeholder, 
        input_onChange,
        input_invalid_feedback,
        input_is_required,
        input_parent,
        input_helper,
        input_rows
      } = this.props;
    return (
      <div>
        <label className="form-control-label">{ this.props.input_label }</label>
        <Editor
          editorState={editorState}
          wrapperClassName="antieditor-wrapper"
          editorClassName="antieditor-editor"
          toolbarClassName="antieditor-toolbar"
          onEditorStateChange={this.onEditorStateChange}
        />
        {input_helper && <small className="help-block">{input_helper}</small>}
        <div className="invalid-feedback">{ input_invalid_feedback }</div>
      </div>
    );
  }
}

export { EditorInput };


// WEBPACK FOOTER //
// ./src/components/EditorInput.js